import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import config from "../../config";
import { useLanguage } from "../../Context";

export default function NewsView() {
  const [items, setItems] = useState(null);
  const [relatedContents, setRelatedContents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { subcategory, id } = useParams();

  const { language } = useLanguage();

  function toHtml(data) {
    return <div className="mb-4" dangerouslySetInnerHTML={{ __html: data }} />;
  }

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    fetch(
      `${config.apiUrl}contentapi.php?option=1&type=6&subcategory=${subcategory}&id=${id}`
    )
      .then((response) => response.json())
      .then((items) => {
        setItems(items);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, [subcategory, id]);

  useEffect(() => {
    fetch(
      `${config.apiUrl}contentapi.php?option=1&type=7&subcategory=${subcategory}&limitCount=4&id=${id}&lang=${language}`
    )
      .then((response) => response.json())
      .then((relatedContents) => setRelatedContents(relatedContents))
      .catch((error) => console.error("Error fetching data", error));
  }, [subcategory, id]);

  const styles = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(16rem, 2fr))",
    gap: "1em",
  };

  if (isLoading) {
    return (
      <div className="container-lg px-0">
        <div className="p-4 bg-secondary-subtle bg-opacity-25">
          <div className="placeholder-glow text-center">
            <div
              className="placeholder col-5 mb-3"
              style={{ height: "3rem" }}
            />
            <br />
            <div className="placeholder col-3 mb-3" />
            <div
              className="placeholder col-10 mb-3"
              style={{ height: "25rem" }}
            />
          </div>
          <div className="col-10 mx-auto">
            <div className="placeholder col-12 mb-2" />
            <div className="placeholder col-12 mb-2" />
            <div className="placeholder col-12 mb-2" />
            <div className="placeholder col-7 mb-2" />
          </div>
        </div>
        <div className="p-4">
          <div style={styles}>
            {[...Array(4)].map((_, index) => (
              <div key={index} className="bg-body-secondary">
                <div
                  className="w-100 placeholder"
                  style={{ height: "10rem" }}
                />
                <div className="p-3">
                  <div className="col-8 placeholder" />
                  <div className="col-12 placeholder" />
                  <div className="col-6 placeholder" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // error if data is not fetched
  if (error) {
    return (
      <div className="max-container-width pt-4 pb-3">
        <p className="alert alert-danger" role="alert" dir="ltr">
          Something went wrong: {error.message}
        </p>
      </div>
    );
  }

  const relatedArticles = relatedContents.map((article) => (
    <Link
      key={article.id}
      className="card text-dark"
      to={`/news/${article.SubCategory}/${article.id}`}
    >
      <div className="ratio ratio-16x9">
        <img
          src={article.ImageUrl?.replace(
            /_large(?=\.(jpg|jpeg|png)$)/,
            "_thumb"
          )}
          alt="news thumbnail"
          className="card-img-top w-100 h-100 object-fit-cover"
        />
      </div>
      <div className="card-body">
        <h5 className="card-text text-truncate">{article.Title}</h5>
        <small dir="ltr">{article.PostDate}</small>
        <div>{article.ShortDesc?.slice(0, 85)}...</div>
      </div>
    </Link>
  ));

  return (
    <>
      <div className="container-lg px-0">
        {items.map((news) => {
          return (
            <div
              className="p-4 bg-secondary-subtle bg-opacity-25"
              key={news.id}
            >
              <div className="text-center">
                <h1>{news.Title}</h1>
                <p>{news.PostDate}</p>
                <img src={news.ImageUrl} alt="" className="mb-3 col-10" />
              </div>
              <div className="col-10 mx-auto">{toHtml(news.fulldesc)}</div>
            </div>
          );
        })}
        <div className="p-4">
          <h4>موضوعات مرتبط</h4>
          <div style={styles}>{relatedArticles}</div>
        </div>
      </div>
    </>
  );
}
